const colors = {
  brand: {
    901: '#002D45a6',
    900: '#002D45',
    700: '#848484',
    200: '#DDDDDD',
    100: '#5DE23D',
    50: '#97EE85',
    20: '#E6E6E6',
    11: '#fcfcfca6',
    10: '#fcfcfc',
    0: '#FFFFFF',
  },
  brandGreen:
      {
        50: '#e6fee2',
        100: '#c4f6b8',
        200: '#a0ee8e',
        300: '#7ce863',
        400: '#58e137',
        500: '#3fc81e',
        600: '#2f9b15',
        700: '#206f0d',
        800: '#104405',
        900: '#001800',
      },
  brandBlue:
      {
        50: '#dff7ff',
        100: '#b3e4ff',
        200: '#85d3fd',
        300: '#58c0fb',
        400: '#36aefa',
        500: '#2796e1',
        600: '#1a74af',
        700: '#0e537e',
        800: '#00324d',
        900: '#00121d',
      },
  // item 406 — was #ef6060 (a red masquerading as "warning"); no component consumed
  // it directly, and the tenant override (brand.warningColor) still replaces it
  warning: {
    400: '#ed8936',
  },
};
export default colors;
